import React, { createContext, useRef } from "react"
import Toast from "../components/atoms/misc/Toast.atom"

/** @typedef {import("./ToastContext.context.types.d.ts").context} context */

const ToastContext = createContext(
  /** @type {context} */
  (null)
)
export default ToastContext

export function ToastContextProvider({ children }) {
  const toast = useRef(null)
  const toastBR = useRef(null)

  return (
    <>
      <ToastContext.Provider value={{ toast, toastBR }}>
        {children}
        <Toast ref={toast} />
        <Toast ref={toastBR} position="bottom-right" />
      </ToastContext.Provider>
    </>
  )
}
